/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Reset_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "This sets the clock back to full round time for every table. There is no undo." |
*
* @param {Timer_Reset_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_reset_confirm_body = /** @type {((inputs?: Timer_Reset_Confirm_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Reset_Confirm_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela réinitialise l'horloge à la durée de ronde complète pour chaque table. Cette action est irréversible.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto reinicia el reloj al tiempo de ronda completo en cada mesa. Esta acción no se puede deshacer.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso reinicia o relógio para o tempo de rodada completo em cada mesa. Esta ação não pode ser desfeita.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo reimposta l'orologio al tempo del round completo per ogni tavolo. Questa azione non può essere annullata.")
	return /** @type {LocalizedString} */ ("This sets the clock back to full round time for every table. There is no undo.")
});